module.exports = __webpack_public_path__ + "static/media/logo_animado_back.666a11c4.gif";